class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay') ? this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)) : '';
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  // add progress bar by inital open:
  
  //  setTimeout(function(){
    var limits = $('.shipping_limit').val();
    limits = parseInt(limits);
    fetch('/cart.js')
              .then(response => response.json())
              .then(data => {
                if(data.item_count > 0)
                {
                  $('.progress_bar').show();
                  $('.progress_bar').css('width','0px');
                  let total_price = data.total_price;
                  total_price = Math.round(100 * data.total_price / limits);
                  total_price <=100 ? $('.progress_bar').css('width',`${total_price}%`) : $('.progress_bar').css('width','100%');
                  let bal_price_shipping = limits-data.items_subtotal_price;
                
                  //let prices = window.theme.Currency.formatMoney(bal_price_shipping,window.Shopify.currency.active);
                  
                  let price = Shopify.formatMoney(bal_price_shipping);
                  if(bal_price_shipping < 0){
                    $('.txt_price').html('Yes! Your package will be shipped for free!');
                  }
                  else{
                    $('.txt_price').html(`You are ${price} away from free shipping. `);
                  }
                }else{
                  $('.progress_bar').hide()
                }
              });
  //  },500); 
    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    
    this.querySelector('.drawer__inner')? this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty') : '';
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
 
     
    setTimeout(() => {
     this.querySelector('#CartDrawer-Overlay') ?  this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)) : '';
      this.open();
      console.log('opppppppppppp');
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

$('.multi_qty_btn').click(function(){
  if($(this).attr('name') == 'minus')
      {
        let getVal = $(this).next().val();
        if(getVal == 1 && getVal !== 0) $(this).next().val(getVal-1);
      }
  let inputLeng = $('.multi_product_input').length;
  let totalQty = 0
  for(let i=0;i<inputLeng;i++)
      {
       totalQty += parseInt($('.multi_product_input').eq(`${i}`).val());
        
      }
  
      if(totalQty >=3)
      {
        $('.multi_product_atc').removeAttr('disabled');
        $('.multi_product_atc').removeClass('disable_atc_btn');
      }
      else
      {
        $('.multi_product_atc').attr('disabled','disabled');
        $('.multi_product_atc').addClass('disable_atc_btn');
      }
      
      
})
$('.multi_product_atc').click(function(e){
  e.preventDefault();
  const triggerOPen = new CartDrawer();
  $('.pack_msg').hide();
  let val=0;
  let obj =[];
  let getlen = $('.multi_product_input').length;
  
  
      for(let i=0;i<getlen;i++)
      {
        if($('.multi_product_input').eq(`${i}`).val() > 0)
        {
          val += parseInt($('.multi_product_input').eq(`${i}`).val());
          let url = $('.multi_product_input').eq(`${i}`).attr('data-url');
          obj.push({id:$('.multi_product_input').eq(`${i}`).attr('variant_id'),quantity:parseInt($('.multi_product_input').eq(`${i}`).val()),sections:'cart-drawer,cart-icon-bubble',sections_url:url})
        }
      }
  
        if(val >=3)
        {
         $('#multi_loader').removeClass('hidden')
          let ids = $(this).attr('variant_id');
          let qty = parseInt($('.multi_product_input').val());
          
           const body = JSON.stringify({
           // line,
            qty,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          });
          
           $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      dataType: 'json',
                      data:{items:obj},
                      success: function(res)
                      {
                        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                          .then((response) => {
                        
                            return response.json();
                          })
                          .then((parsedState) => 
                            {
                             $('#multi_loader').addClass('hidden')
                             $('.drawer').addClass('animate active');
                             $('.drawer').removeClass('is-empty');
                             triggerOPen.renderContents(parsedState);  
                          })
                      }
                  });  
        }
        else{
         // $('.pack_msg').show();
        }
  })
   $('.single_product_btn').click(function(e){
     e.preventDefault();
     let ids = $(this).attr('id');
     let qty = $('.sgl-'+ids).val();
     let url = $(this).attr('data-url');
     const triggerOPensgl = new CartDrawer();
     qty = parseInt(qty);
     $('#loader_'+ids).removeClass('hidden');
      $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      dataType: 'json',
                      data:{id:ids,quantity:qty,sections:'cart-drawer,cart-icon-bubble',sections_url:url},
                      success: function(res)
                      {
                       
                        let ele = document.querySelector('#cart-icon-bubble');
                        $('#loader_'+ids).addClass('hidden');
                        $('.drawer').addClass('animate active');
                        
                        $('.drawer').removeClass('is-empty');
                        triggerOPensgl.renderContents(res);
                      }
                  });  
   })

$(document).on('click','#CartDrawer-Overlay',function(){
 $('.drawer').removeClass('animate active'); 
  $('body').removeClass('overflow-hidden');
})

$('.quick_close').click(function()
 {
    $('.quick_buy_popup').slideUp('slow');
    $('html, body').animate({
      scrollTop: $(this).closest('.bundle-single-product_inner').offset().top-100
  }, 1000);
})

$('.ex_plus_btn').click(function(e)
 {
      e.preventDefault();
    
      let ids = $(this).attr('id').split('_')[1];
      $('.quick_buy_popup').hide();
      $('#quick_'+ids).slideDown('slow',function(){
             $('html, body').animate({
        scrollTop: $('#quick_'+ids).offset().top-100
    }, 1000);
  });


   
})